var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".star{font-size:0}.star-item{display:inline-block;background-repeat:no-repeat;width:.4rem;height:.42rem;margin-right:.22rem;background-size:100%}.star-item.on{background-image:url(" + escape(require("../../assets/images/star2.png")) + ")}.star-item.off{background-image:url(" + escape(require("../../assets/images/star1.png")) + ")}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-46a38f61","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/satisfaction/star.vue
// module id = +nIn
// module chunks = 1